import type { PlatformApiMethods } from '@wix/editor-platform-host-integration-apis';
import type { DocumentServicesObject } from '@wix/document-services-types';
import type {
  TPAHandler,
  TPAMessage,
  TPAMessageCallback,
} from '../../types/tpaMessage';
import type { TpaStyleService } from '../../services';
import { ComponentRef } from '@wix/editor-platform-sdk-types';

export function createStyleHandlers(
  platformApiMethods: PlatformApiMethods,
  _documentServicesAPI: DocumentServicesObject,
  tpaStyleService: TpaStyleService,
) {
  const createSetStyleParamHandler =
    (isGlobal: boolean): TPAHandler =>
    async (msg: TPAMessage, callback: TPAMessageCallback) => {
      const editorPointer =
        platformApiMethods.editor.getEditorPointerFromCompId?.(msg.compId);

      const editorPointerWithCurrentVariants =
        platformApiMethods.editor.stage?.getPointerWithCurrentVariants(
          editorPointer,
        );
      const compRef =
        (editorPointerWithCurrentVariants?.documentPointer as ComponentRef) ??
        editorPointer?.documentPointer ??
        platformApiMethods.editor.getCompRefFromCompId?.(msg.compId);

      tpaStyleService.setStyleParam(compRef, msg.data, callback, isGlobal);
    };

  return {
    setStyleParam: createSetStyleParamHandler(false),
    setGlobalStyleParam: createSetStyleParamHandler(true),
  };
}
